<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <!--查询-->
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="年月">
              <el-select v-model="q.yearMonth" placeholder="请选择" clearable style="width:100%">
                <el-option v-for="item in yearMonthList" :key="item" :label="item" :value="item"/>
              </el-select>
            </el-form-item>
            <el-form-item label="平台商编码/名称">
              <el-input v-model="q.ptCodeName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="物料编码/名称">
              <el-input v-model="q.materialCodeName" placeholder="请输入" clearable/>
            </el-form-item>
          </div>
        </el-form>
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
            <el-button class="h-btn h-formBtn h-bggreen" @click="openOfflineOutbound">线下出库</el-button>
            <!-- 暂时隐藏：生成报表按钮 -->
            <!--<el-button class="h-btn h-formBtn h-bggreen" @click="handleGenerate">生成报表</el-button>-->
          </div>
        </div>
      </div>
      <!--数据展示-->
      <div class="h-table h-mrt30">
        <el-table
            :data="tableData"
            ref="multipleTable"
            stripe border
            style="width: 100%"
            max-height="450"
            show-summary
            :summary-method="getSummaries"
        >
          <el-table-column prop="yearMonth" label="年月" width="70"/>
<!--          <el-table-column prop="ptCode" label="平台商编码" width="120" show-overflow-tooltip/>-->
          <el-table-column prop="ptName" label="平台商名称" min-width="120" show-overflow-tooltip/>
          <el-table-column prop="materialCode" label="物料编码" width="130" show-overflow-tooltip/>
          <el-table-column prop="materialName" label="物料名称" min-width="150" show-overflow-tooltip/>
          <el-table-column prop="openingStock" label="期初库存" width="80"/>
          <el-table-column prop="openingAmount" label="期初金额" width="100"/>
          <el-table-column prop="inQty" label="入库数量" width="80"/>
          <el-table-column prop="inAmount" label="入库金额" width="100"/>
          <el-table-column prop="outQty" label="出库数量" width="80"/>
          <el-table-column prop="outAmount" label="出库金额" width="100"/>
          <el-table-column prop="balance" label="结余数量" width="80"/>
          <el-table-column prop="balanceAmount" label="结余金额" width="100"/>
          <el-table-column label="操作" width="90" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="goDetail(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableBL">
          <el-button class="h-btn h-formBtn h-bgblueQ" @click="exportExcel">批量导出</el-button>
        </div>
        <div class="h-pagination2">
          <pagination :page="q" @query="query"/>
        </div>
      </div>
    </div>

    <!-- 线下出库弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="offlineDialogVisible"
               class="h-dialog2 offline-outbound-dialog" width="750px" @close="cancelOffline">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>线下出库</h1>
            <p>Offline Outbound</p>
          </div>
        </div>
      </div>
      <div class="h-formLine h-mrb-38">
        <el-form :model="offlineForm" :rules="offlineRules" ref="offlineForm"
                 :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
          <el-form-item label="订单编码" class="h-elformWrap-2" prop="firstSapCode">
            <el-input v-model="offlineForm.firstSapCode" placeholder="请输入SWN订单编码"
                      clearable @change="onSapCodeChange"/>
          </el-form-item>
          <el-form-item label="平台商" class="h-elformWrap-2">
            <el-input :value="offlineForm.ptName" disabled/>
          </el-form-item>
          <el-form-item label="产品编码" class="h-elformWrap-2">
            <el-input v-model="offlineForm.materialCode" placeholder="SWN订单自动带出" disabled/>
          </el-form-item>
          <el-form-item label="产品名称" class="h-elformWrap-2">
            <el-input v-model="offlineForm.materialName" placeholder="SWN订单自动带出" disabled/>
          </el-form-item>
          <el-form-item label="收货单位" class="h-elformWrap-2" prop="soldToName">
            <el-input v-model="offlineForm.soldToName" placeholder="请输入收货单位" clearable/>
          </el-form-item>
          <el-form-item label="收货地址" class="h-elformWrap-2">
            <el-input v-model="offlineForm.receivingAddress" placeholder="请输入收货地址" clearable/>
          </el-form-item>
          <el-form-item label="出库数量" class="h-elformWrap-2" prop="proNumber">
            <el-input-number v-model="offlineForm.proNumber" :min="1" :max="999999" style="width:100%"/>
          </el-form-item>
          <el-form-item label="出库日期" class="h-elformWrap-2" prop="outboundDate">
            <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
                            v-model="offlineForm.outboundDate" style="width:100%"/>
          </el-form-item>
          <el-form-item label="联系人电话" class="h-elformWrap-2">
            <el-input v-model="offlineForm.contactPhone" placeholder="请输入联系人电话" clearable/>
          </el-form-item>
          <el-form-item label="联系人名称" class="h-elformWrap-2">
            <el-input v-model="offlineForm.contactName" placeholder="请输入联系人名称" clearable/>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-formBtn h-bgwhite" @click="cancelOffline">取消</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ2" @click="submitOfflineOutbound" :loading="offlineSubmitting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ss from "@/api/SystemService";
import updownfile from "@/utils/updownfile";

export default {
  data() {
    return {
      q: {
        yearMonth: '',
        ptCodeName: '',
        materialCodeName: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      yearMonthList: [],
      // 线下出库弹窗
      offlineDialogVisible: false,
      offlineSubmitting: false,
      offlineForm: {
        firstSapCode: '',
        soldToName: '',
        materialCode: '',
        materialName: '',
        proNumber: 1,
        unitPrice: null,
        receivingAddress: '',
        contactPhone: '',
        contactName: '',
        outboundDate: '',
        ptName: '',
      },
      offlineRules: {
        firstSapCode: [{ required: true, message: '请输入订单编码', trigger: 'blur' }],
        soldToName: [{ required: true, message: '请输入收货单位', trigger: 'blur' }],
        proNumber: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        outboundDate: [{ required: true, message: '请选择出库日期', trigger: 'change' }],
      },
    }
  },
  methods: {
    handleFilter() {
      this.q.pageNo = 1
      this.query()
    },
    resetData() {
      this.q = {
        yearMonth: '',
        ptCodeName: '',
        materialCodeName: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
      this.query()
    },
    query() {
      // 默认当前月
      if (!this.q.yearMonth) {
        let now = new Date();
        this.q.yearMonth = now.getFullYear() + String(now.getMonth() + 1).padStart(2, '0');
      }
      let params = { ...this.q }
      // 平台商编码/名称 联合搜索 → ptKeyword
      if (params.ptCodeName) {
        params.ptKeyword = params.ptCodeName
      }
      // 物料编码/名称 联合搜索 → materialKeyword
      if (params.materialCodeName) {
        params.materialKeyword = params.materialCodeName
      }
      ss.bscHhptInventoryReport.selectReportPage(params).then(res => {
        this.tableData = res.records;
        this.q.total = res.total;
      })
    },
    handleGenerate() {
      let yearMonth = this.q.yearMonth;
      if (!yearMonth) {
        let now = new Date();
        yearMonth = now.getFullYear() + String(now.getMonth() + 1).padStart(2, '0');
      }
      this.$confirm('确定要生成 ' + yearMonth + ' 月份的库存月报吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ss.bscHhptInventoryReport.generateReport(yearMonth).then(res => {
          if (res.f) {
            this.$message.success('报表生成成功');
            this.query();
            this.getYearMonths();
          }
        })
      }).catch(() => {});
    },
    exportExcel() {
      let params = { ...this.q }
      if (params.ptCodeName) {
        params.ptKeyword = params.ptCodeName
      }
      if (params.materialCodeName) {
        params.materialKeyword = params.materialCodeName
      }
      updownfile.down("/api/swyl/v1/inventoryReport/bscHhptInventoryReport/downloadExcel", params, "get");
    },
    // ---- 线下出库 ----
    openOfflineOutbound() {
      const today = new Date();
      const yyyyMMdd = today.getFullYear() + '-'
        + String(today.getMonth() + 1).padStart(2, '0') + '-'
        + String(today.getDate()).padStart(2, '0');
      this.offlineForm = {
        firstSapCode: '',
        soldToName: '',
        materialCode: '',
        materialName: '',
        proNumber: 1,
        unitPrice: null,
        receivingAddress: '',
        contactPhone: '',
        contactName: '',
        outboundDate: yyyyMMdd,
        ptName: (this._user && this._user.username) || '',
      };
      this.offlineDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.offlineForm && this.$refs.offlineForm.clearValidate();
      });
    },
    // 订单编码变更，校验SWN并查询产品信息
    onSapCodeChange() {
      let code = this.offlineForm.firstSapCode;
      if (!code) {
        this.offlineForm.materialCode = '';
        this.offlineForm.materialName = '';
        this.offlineForm.unitPrice = null;
        return;
      }
      code = code.toUpperCase();
      this.offlineForm.firstSapCode = code;
      if (!code.startsWith('SWN')) {
        this.offlineForm.materialCode = '';
        this.offlineForm.materialName = '';
        this.offlineForm.unitPrice = null;
        this.$message.warning('请输入正确的SWN订单编码');
        return;
      }
      ss.bscHhptInventoryRecord.getOrderProductInfo(code).then(res => {
        if (res.f && res.obj) {
          this.offlineForm.materialCode = res.obj.materialCode || '';
          this.offlineForm.materialName = res.obj.materialName || '';
          this.offlineForm.unitPrice = res.obj.unitPrice || null;
        } else {
          this.offlineForm.materialCode = '';
          this.offlineForm.materialName = '';
          this.offlineForm.unitPrice = null;
          this.$message.warning(res.msg || '未找到该订单的产品信息');
        }
      });
    },
    cancelOffline() {
      this.offlineDialogVisible = false;
      this.$refs.offlineForm && this.$refs.offlineForm.resetFields();
    },
    submitOfflineOutbound() {
      this.$refs.offlineForm.validate(valid => {
        if (!valid) return;
        if (!this.offlineForm.firstSapCode || !this.offlineForm.firstSapCode.toUpperCase().startsWith('SWN')) {
          this.$message.warning('请输入正确的SWN订单编码');
          return;
        }
        this.offlineSubmitting = true;
        ss.bscHhptInventoryRecord.createOfflineOutbound(this.offlineForm).then(res => {
          this.offlineSubmitting = false;
          if (res.f) {
            this.$message.success('线下出库记录创建成功');
            this.offlineDialogVisible = false;
            this.query();
            this.getYearMonths();
          }
        }).catch(() => {
          this.offlineSubmitting = false;
        });
      });
    },
    // 表格底部合计行
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      const sumCols = ['openingStock', 'openingAmount', 'inQty', 'inAmount', 'outQty', 'outAmount', 'balance', 'balanceAmount'];
      columns.forEach((col, i) => {
        if (i === 0) { sums[i] = '合计'; return; }
        if (sumCols.includes(col.property)) {
          sums[i] = data.reduce((acc, row) => acc + (Number(row[col.property]) || 0), 0);
          if (col.property === 'openingAmount' || col.property === 'inAmount' || col.property === 'outAmount' || col.property === 'balanceAmount') {
            sums[i] = sums[i].toFixed(2);
          }
        } else {
          sums[i] = '';
        }
      });
      return sums;
    },
    goDetail(row) {
      this.$router.push({
        path: '/loud/inventoryRecord',
        query: {
          yearMonth: row.yearMonth,
          ptCode: row.ptCode,
          materialCode: row.materialCode
        }
      });
    },
    getYearMonths() {
      ss.bscHhptInventoryReport.getYearMonths().then(res => {
        if (res.f) {
          this.yearMonthList = res.obj || [];
        }
      })
    },
  },
  created() {
    this.getYearMonths();
    this.query();
  },
  activated() {
    this.query()
  }
}
</script>
<style lang="less" scoped>
</style>
<style lang="less">
// 线下出库弹窗头部背景图自适应宽度
.offline-outbound-dialog .h-dialogImg {
  background-size: cover;
}
</style>
